import { gql } from "@apollo/client";

export default gql`
  fragment AssessmentNomination on AssessmentOpenForNominationNode {
    id
    complianceProgram {
      id
      title
    }
    assessmentTemplate {
      id
      assessmentType
    }
    targetUser {
      id
      name
      avatar
    }
    nominationsCount
  }
`;
